module.exports = __webpack_public_path__ + "assets/images/b5x6hLKKa9.png";


//////////////////
// WEBPACK FOOTER
// ../assets/images/hua.png
// module id = 2201
// module chunks = 0